<template>
  <div class="weui-cells weui-cells_form" style="background: white">
    <h3 class="page__title">发票申请管理</h3>
    <div class="weui-cell weui-cell_active weui-cell_vcode" style="color: black">
        <div class="weui-cell__hd">
            <label class="weui-label">处理状态</label>
        </div>
        <div class="weui-cell__bd weui-cell__bd-WU">
            <input class="weui-input" style="text-align:center" type="text" placeholder="1 待处理，2 处理完毕" v-model="state" />
        </div>
    </div>
    <div class="weui-cell weui-cell_active weui-cell_vcode" style="color: black">
        <div class="weui-cell__hd">
            <label class="weui-label">商户ID</label>
        </div>
        <div class="weui-cell__bd weui-cell__bd-WU">
            <input class="weui-input" style="text-align:center" type="text" placeholder="输入提现商户号" v-model="partnerid" />
        </div>
    </div>
    <div class="weui-cell weui-cell_active weui-cell_vcode" >
        <div class="weui-cell__hd">
        </div>
        <div class="weui-cell__bd">
          <a @click="getMyInvoiceRecords" class="weui-btn weui-btn_primary">查询</a>
        </div>
    </div>
    <div v-if="(recordsInVoice != null) && ( recordsInVoice.length > 0)">
     <hr/>
      <table class="table table-striped " style="font-size: small;" >
            <thead>
               <td>申请时间</td>
               <td>商户</td>
               <td>金额</td>
               <td>状态</td>
            </thead>
            <tbody style="padding: 0px;margin:0px">
              <tr v-for="rcd in recordsInVoice" :key="rcd.id" @click="invoiceComplatePre(rcd)">
                <td>{{ rcd.createTime }}</td>
                <td>{{ rcd.partnerId }}</td>
                <td>{{ fenToCNY( rcd.amount) }}</td>
                <td>{{ getRState(rcd.invoiceFlag) }}</td>
              </tr>
            </tbody>
            <tfoot>

            </tfoot>
          </table>
    </div>
    <div class="weui-mask" id="iosMaskDlg" style="display: none;" @click="hideDlg"></div>
    <div class="weui-actionsheet" id="curRecordDlg">
      <!--
        <div class="weui-actionsheet__title">
            <p class="weui-actionsheet__title-text">{{title}}</p>
        </div>
      -->
        <div class="weui-actionsheet__menu" v-if="curRecord != null">
          <table class="table table-striped " style="font-size: small;" >
            <tr><td>申请时间</td><td>{{ curRecord.createTime }} <a style="color: blue;" @click="toUrl(curRecord.userAccount)">看用户信息</a></td></tr>
            <!--<tr><td>商户号</td><td>{{ curRecord.partnerId }}</td></tr>       -->
            <tr><td>金额</td><td>{{ fenToCNY(curRecord.amount) }}</td></tr>
            <tr><td>状态</td><td>{{ getRState(curRecord.invoiceFlag  ) }}</td></tr>

            <tr v-if="invoiceInfo != null"><td>开票信息</td><td>
              <table>
                <tr><td>抬头</td><td>{{ invoiceInfo.title }}</td></tr>
                <tr><td>税号</td><td>{{ invoiceInfo.taxNumber    }}</td></tr>
                <tr><td>地址</td><td>{{ invoiceInfo.address      }}</td></tr>
                <tr><td>电话</td><td>{{ invoiceInfo.telephone }}</td></tr>
                <tr><td>开户行</td><td>{{ invoiceInfo.bankName }}</td></tr>
                <tr><td>账户</td><td>{{ invoiceInfo.bankAccount }}</td></tr>
                <tr><td>类型</td><td>{{ getRSType( invoiceInfo.type )}}</td></tr>
                <tr><td>邮箱</td><td>{{ invoiceInfo.email }}</td></tr>
              </table>
            </td></tr>

            <tr v-if="curRecord.invoiceFlag   != 2 "><td>操作</td>
              <td><a class="weui-btn weui-btn_primary" @click="invoiceComplate(curRecord.orderId)">确认已经开票</a></td>
            </tr>
          </table>
        </div>
        <!--
        <div class="weui-actionsheet__action">
            <div class="weui-actionsheet__cell" id="iosActionsheetCancel">关闭</div>
        </div>
      -->
    </div>
  </div>
</template>

<style>
.a_hot_touch{color:blue;font-style:italic;text-decoration:underline;}
</style>

<script>

import axios from "axios"
import JQ from 'jquery'
import wx from 'jweixin-1.6.0';
import {getInvoiceRecords,getInvoiceOfUser} from '../graphql/api'

export default {
data () {
  return {
    ing:true,
    partnerid:"",
    state:1,
    recordsInVoice:null,
    curRecord:null,
    invoiceInfo:null
  }
},
mounted() {
     this.partnerid = sessionStorage.getItem("partnerid")

     this.getMyInvoiceRecords();
},
methods: {
  fenToCNY(fen){
    let prefix = "";
    let res= ""
    let intv = parseInt(fen)

    if(intv < 0) {
      intv = Math.abs(intv);
      prefix = "-";
    }

    if(intv <= 9){
      res = "0.0"+ ( intv).toString();
    }else if(intv <= 99){
      res =  "0."+ ( intv).toString();
    }else {
      res = intv.toString();

      res = res.substring(0,res.length-2) + "." + res.substring(res.length-2)
    }
    return prefix+res;

 },

  getMyInvoiceOfUser(){

    let that = this
    let paras = {};

    paras.acc = this.curRecord.userAccount;

    getInvoiceOfUser(paras)
    // findAllWeChatAccDailyStatement(that.partnerid,{bd:"2022-12-01",ed:"2022-12-05 23:59:59",ls:[1,2],lt:[1,2,3,4]})
    .catch(err=>{
      console.log(err)
    })
    .then(res1=>{
     // alert(1)
      console.info('获取数据=》'+JSON.stringify(res1.data))
      //alert(JSON.stringify(res1.data))
      that.invoiceInfo = res1.data.findInvoiceInfoByUserAccountAndState

      console.log(that.invoiceInfo);

      that.showDlg();


    })
  },toUrl(openid){
      this.$router.push({name:"userlist",params:{
        userAccount:openid
      }});
    },
  getMyInvoiceRecords(){
    let that = this
    let paras = {};

    paras.pid = /*(this.partnerid == "M2022060601") ? null: */this.partnerid ;
    paras.state = this.state;

    getInvoiceRecords(paras)
    // findAllWeChatAccDailyStatement(that.partnerid,{bd:"2022-12-01",ed:"2022-12-05 23:59:59",ls:[1,2],lt:[1,2,3,4]})
    .catch(err=>{
      console.log(err)
    })
    .then(res1=>{
     // alert(1)
      console.info('获取数据=》'+JSON.stringify(res1.data))
      //alert(JSON.stringify(res1.data))
      that.recordsInVoice = res1.data.findInvoiceOrder

    })
  },
  getRState(istate){if(istate == 2) return "成功"; return "处理中"},
  getRSType(istate){if(istate == 0) return "普票"; return "专票"},
  fenToCNY(fen){
    let prefix = "";
    let res= ""
    let intv = parseInt(fen)

    if(intv < 0) {
      intv = Math.abs(intv);
      prefix = "-";
    }

    if(intv <= 9){
      res = "0.0"+ ( intv).toString();
    }else if(intv <= 99){
      res =  "0."+ ( intv).toString();
    }else {
      res = intv.toString();

      res = res.substring(0,res.length-2) + "." + res.substring(res.length-2)
    }
    return prefix+res;

  },
  toDir(str) {
      this.$router.push({
        name: str /*,
        params: {
          dateStr: date,
          state: state,
          posid: 0
        }*/
      });
    },
    hideDlg(){
      JQ('#curRecordDlg').removeClass('weui-actionsheet_toggle up80px');
      JQ('#iosMaskDlg').fadeOut(200);
    },
    showDlg(){
      JQ('#curRecordDlg').addClass('weui-actionsheet_toggle up80px');
      JQ('#iosMaskDlg').fadeIn(200);
    },
    invoiceComplatePre(rcd){
      console.log(rcd)
      this.curRecord = rcd
      this.getMyInvoiceOfUser()
    },
    invoiceComplate(tid) {
      console.log("invoiceComplate")


    let paras = {};

    paras.orderId = tid;
    paras.invoiceFlag = 2;

      let that = this;
      axios.post('customer/omc/invoiceLabel',paras)
      .then(function (response) {
        console.log(response);
        if(response.data.retcode == 0){
          that.getMyInvoiceRecords();
        }else{

          alert(response.data.retmsg)
        }

        that.hideDlg()

      })
      .catch(function (error) {
        console.log(error);
      });
    }
 }
}
</script>



// WEBPACK FOOTER //
// src/views/invoice_apply_mgr.vue